import { render, staticRenderFns } from "./TheWorkspaces.vue?vue&type=template&id=11bbb65f&scoped=true&"
import script from "./TheWorkspaces.vue?vue&type=script&lang=js&"
export * from "./TheWorkspaces.vue?vue&type=script&lang=js&"
import style0 from "./TheWorkspaces.vue?vue&type=style&index=0&id=11bbb65f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bbb65f",
  null
  
)

export default component.exports